import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useThemeProps } from '@mui/material';
import { ActionBarAlign } from './constants.js';
import { getActionBarTextAlign, getActionBarFlexAlign } from './utils.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinActionBarItem",
  slot: "Root",
  skipForwardProps: ["align", "verticalAlign", "fluid"]
});

var ActionBarItemBase = function ActionBarItemBase(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(componentRoot.className, className)
  }, children);
};

ActionBarItemBase.propTypes = {
  children: propTypes.node,
  align: propTypes.any,
  verticalAlign: propTypes.any,
  fluid: propTypes.bool,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var ActionBarItemRoot = styled(ActionBarItemBase, componentRoot.styledOptions)(function (_ref2) {
  var _ref2$align = _ref2.align,
      align = _ref2$align === void 0 ? ActionBarAlign.Left : _ref2$align,
      verticalAlign = _ref2.verticalAlign,
      fluid = _ref2.fluid;
  return {
    flex: fluid ? "auto" : undefined,
    textAlign: getActionBarTextAlign(align),
    alignSelf: verticalAlign ? getActionBarFlexAlign(verticalAlign) : undefined
  };
});
/**
 * A container for a single action
 */

var ActionBarItem = function ActionBarItem(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(ActionBarItemRoot, rootProps);
};

var ActionBarItem$1 = ActionBarItem;

export { ActionBarItem$1 as default };
